//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { find } from 'lodash';
import {
    mergeSubmissionUpdate,
    mergeSubmissionsListPayload
} from 'utils/mergeSubmissionUpdate';
//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const submissionsInitial = [];

export const submissions = (state = submissionsInitial, action) => {
    switch (action.type) {
        case ActionTypes.submissions.createSubmissionSuccess:
            return [action.payload, ...state];
        case ActionTypes.submissions.updateSubmissionSuccess:
            const is_exists = state.find(x => x?.id === action.payload?.id);
            if (is_exists) {
                return state.map(x =>
                    x?.id === action.payload?.id ? mergeSubmissionUpdate(x, action.payload) : x
                );
            } else {
                if (action.payload?.id) {
                    return [...state, action.payload];
                } else {
                    return state;
                }
            }
        case ActionTypes.submissions.realTimeSubmissionSuccess:
            const existingIndex = state.findIndex(x => x?.id === action.payload?.id);
            if (existingIndex !== -1) {
                return state.map((item, index) =>
                    index === existingIndex ? mergeSubmissionUpdate(item, action.payload) : item
                );
            }
            return [action.payload, ...state];
        case ActionTypes.submissions.updateSubmissionInBatchSuccess:
            return state.map((item) => {
                const updatedItem = action.payload.find(x => x.id === item.id);
                return updatedItem ? mergeSubmissionUpdate(item, updatedItem) : item;
            }).concat(
                action.payload.filter(x => !state.find(y => y.id === x.id))
            );
        case ActionTypes.submissions.deleteUserSubmissionSuccess:
            return state.filter(x => !find(action.payload, ['id', x.id]));
        case ActionTypes.submissions.listQuestionsSuccess:
            return action.payload;
        case ActionTypes.submissions.listAssignmentSubmissionsSuccess:
            return mergeSubmissionsListPayload(state, action.payload);
        case ActionTypes.submissions.listClassSubmissionsSuccess:
        case ActionTypes.submissions.listOrgSubmissionsSuccess:
        case ActionTypes.submissions.listUserSubmissionsSuccess:
            return mergeSubmissionsListPayload(state, action.payload);
        case ActionTypes.submissions.createSubmissionFail:
        case ActionTypes.submissions.updateSubmissionFail:
        case ActionTypes.submissions.listQuestionsFail:
        case ActionTypes.submissions.listAssignmentSubmissionsFail:
        case ActionTypes.submissions.listClassSubmissionsFail:
        case ActionTypes.submissions.listOrgSubmissionsFail:
        case ActionTypes.submissions.listUserSubmissionsFail:
            return state;
        case ActionTypes.submissions.updatePastSubmissions:
            return state.map(x => {
                if (x.id === action.payload.submissionId) {
                    if (Array.isArray(x.pastSubmissions)) {
                        let _pastSubmissions = x.pastSubmissions;
                        _pastSubmissions.push(action.payload)
                        x.pastSubmissions = _pastSubmissions
                        return x
                    } else {
                        x.pastSubmissions = [action.payload]
                        return x
                    }
                }
                return x;
            });
        default:
            return state;
    }
};
